
import { computed, defineComponent, reactive } from 'vue';

import Banner from '@/components/Banner.vue';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserExamService } from '@/services/userExam.service';
import { SHOW_BRAND } from '@/utils';
import { UserService } from '@/services/user.service';
import { useRoute, useRouter } from 'vue-router';
import {
  value2label,
  CARD_TYPE,
  SEX,
  GRADE,
  CERTIFICATE_GET_METHODS,
  formatDateToSecond,
  formatTime,
} from '@/utils';
import { UserExam } from '@/types';

import UserCertificate from './components/UserCertificate.vue';
import { environment } from '@/utils/environment';

export default defineComponent({
  name: 'UserItemDetail',
  components: {
    Banner,
    UserCertificate,
  },
  setup() {
    declareProviders([UserExamService]);

    const userExamService = useService(UserExamService);
    const userService = useService(UserService);

    const router = useRouter();
    const route = useRoute();

    const id = +route.params.id;

    userExamService.setUserExamId(id);

    userExamService.getUserExamDetail();

    const userExam = computed<UserExam | void>(() => {
      return userExamService.userExam;
    });

    const hideGetCertification = computed(() => {
      return environment === 'production'
        ? userExamService.userExam.contestInfoId === 797
        : userExamService.userExam.contestInfoId === 36;
    });

    const passedText = computed(() => {
      if (userExam.value) {
        const passDesc = userExam.value.passDesc;
        const passed = userExam.value.passed;
        return passDesc
          ? passDesc
          : passed === 1
          ? '未晋级'
          : passed === 2
          ? '已晋级'
          : passed === 3
          ? '晋级已撤销'
          : '--';
      }
    });

    const awardedText = computed(() => {
      if (userExam.value) {
        const awardDesc = userExam.value.awardDesc;
        const awarded = userExam.value.awarded;
        return awardDesc
          ? awardDesc
          : awarded === 1
          ? '未获奖'
          : awarded === 2
          ? `${userExam.value.awardName}`
          : awarded === 3
          ? '获奖已撤销'
          : '--';
      }
    });

    const costTimeText = computed(() => {
      if (userExam.value) {
        if (userExam.value.costTime === null) {
          return '--';
        } else {
          return formatTime(userExam.value.costTime);
        }
      }
    });

    const showUserCertificate = reactive({
      visible: false,
    });

    const getPlantTextString = (type: string) => {
      userExamService.getPlainText(
        (userExam.value as UserExam).userId,
        (userExam.value as UserExam).contestInfoId,
        type
      );
    };

    const goToExamAnswer = () => {
      router.push({
        name: 'Examination',
        params: {
          id: userExam.value?.userExamId,
          answerId: userExam.value?.answerPaperId,
        },
      });
    };

    const changeInfo = () => {
      router.push({
        name: 'ItemApply',
        params: {
          id: (userExam.value as UserExam).contestInfoId,
        },
        query: {
          userExamId: id,
        },
      });
    };

    const isNocFlag = computed(() => route.query.platform === 'noc');

    return {
      userService,
      SHOW_BRAND,
      userExamService,
      userExam,
      passedText,
      awardedText,
      costTimeText,
      CARD_TYPE,
      SEX,
      GRADE,
      CERTIFICATE_GET_METHODS,
      showUserCertificate,
      getPlantTextString,
      value2label,
      formatDateToSecond,
      goToExamAnswer,
      changeInfo,
      hideGetCertification,
      isNocFlag,
      route,
    };
  },
});
